<div id="app-root">
  <router-outlet>
    <app-loader></app-loader>
  </router-outlet>
</div>
